import { useSelector } from "react-redux";
import User from "./UserModel";

export function canDownload(user?: User | null): boolean {
  if (!user) return false;
  if (user.is_superuser) return true;
  return user.role !== "read_only";
}

export function useCanDownload(): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const user = useSelector((state: any) => state.auth.user);
  return canDownload(user);
}
